import patterns from './crawlerUserAgentPatterns';

export default function isCrawler(userAgent = navigator.userAgent) {
  return patterns.some((pattern) => pattern.test(userAgent));
}
